// Domain
import { RiskToleranceQuestionsEntity } from '../entities/risk-tolerance-questions-entity';

export default class RiskToleranceQuestionsState {
  loaded = false;

  items: Array<RiskToleranceQuestionsEntity> = [];
}
